import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="transparent"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M7.50067 8H3.92772C2.81264 8 2.0874 9.17347 2.58608 10.1708L5.21108 15.4208C5.46516 15.929 5.98456 16.25 6.55272 16.25H9.56601C9.68865 16.25 9.81083 16.235 9.92981 16.2052L12.7507 15.5M7.50067 8V4.25C7.50067 3.42157 8.17224 2.75 9.00067 2.75H9.07227C9.44694 2.75 9.75067 3.05373 9.75067 3.42839C9.75067 3.96412 9.90924 4.48786 10.2064 4.93362L12.7507 8.75V15.5M7.50067 8H9.00067M12.7507 15.5H14.2507C15.0791 15.5 15.7507 14.8284 15.7507 14V9.5C15.7507 8.67157 15.0791 8 14.2507 8H12.3757" />
  </svg>
);
